import { filtersAccordionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFiltersAccordion";
import AccordionSectionPanel from "@insite/mobius/AccordionSection/AccordionSectionPanel";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { ELEMENTS, TYPOGRAPHY } from "@tSurya/theme/design";
import { css } from "styled-components";

filtersAccordionStyles.accordion = {
    css: css`
        padding-top: 0px;
        padding-left: ${ELEMENTS.accordionContainer.desktop.paddingLeft};
        padding-right: 1px;
        ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding-left: ${ELEMENTS.accordionContainer.mobile.paddingLeft};
                            padding-right: 20px;
                        `,
                        css`
                            padding-left: ${ELEMENTS.accordionContainer.mobile.paddingLeft};
                            padding-right: 20px;
                   `,
                         css`
                            padding-left: ${ELEMENTS.accordionContainer.mobile.paddingLeft};
                            padding-right: 20px;
                    `,
                        null,
                        null,
                    ])}
        > div {
            dd {
                border: none;
                /* margin-left: 20px; */
                background: ${getColor("primary.contrast")};
                padding-top: 0px !important;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding-top: 0;
                            padding-right: 0;
                        `,
                        css`
                            padding-top: 0;
                            padding-right: 0;
                        `,
                        css`
                            padding-top: 0;
                            padding-right: 0;
                        `,
                        null,
                        null,
                    ])}
                padding-bottom: 15px;
                border-bottom: 1px solid ${getColor("common.border")};
                div[data-id="checkbox"] {
                                > span[aria-checked="true"] {
                                    background-color: ${ELEMENTS.filterCheckbox.checkedBackground} !important;
                                }
                                > span[role="checkbox"]:focus {
                                    box-shadow: 0 0 0 0;
                                }
                            }
                > div {
                    > div[class^="GridOffset"] {
                        margin: 0px;
                        > div[class^="CheckboxGroupStyle"] {
                            flex-direction: unset;
                            &:not(:last-of-type) {
                                padding-bottom: 6px;
                            }
                            > div[data-id="checkbox"] {
                                > span[aria-checked="true"] {
                                    background-color: ${ELEMENTS.filterCheckbox.checkedBackground} !important;
                                }
                                > span[role="checkbox"]:focus {
                                    box-shadow: 0 0 0 0;
                                }
                            }
                        }
                    }
                }
                > div {
                    label {
                        font-size: ${TYPOGRAPHY.size.small};
                        line-height: ${TYPOGRAPHY.lineHeight.xbase};
                        color: ${getColor("text.accent")};
                        font-weight: ${TYPOGRAPHY.weight.base};
                        font-family: ${TYPOGRAPHY.fontFamily.title};
                    }
                }
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding-top: 0;
                            padding-right: 0;
                        `,
                        css`
                            padding-top: 0;
                            padding-right: 0;
                        `,
                        css`
                            padding-top: 0;
                            padding-right: 0;
                        `,
                        null,
                        null,
                    ])}
            }
            dt {
                /* margin-top: 2px; */
                background: ${getColor("primary.contrast")};
                > button {
                    background: ${getColor("primary.contrast")};
                    border: none !important;
                    &:focus {
                        padding-left: 0;
                        padding-top: 15px !important;
                        padding-bottom: 15px;
                        border: 0px;
                    }
                    padding: 15px 20px 15px 0;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                padding-right: 0px;
                            `,
                            css`
                                padding-right: 0px;
                            `,
                            css`
                                padding-right: 0px;
                            `,
                            null,
                            null,
                        ])}
                    > span:first-of-type {
                        font-size: ${TYPOGRAPHY.accordionItem.size};
                        line-height: ${TYPOGRAPHY.accordionItem.lineHeight};
                        color: ${getColor("text.main")};
                        font-weight: ${TYPOGRAPHY.accordionItem.weight};
                        font-family: ${TYPOGRAPHY.accordionItem.fontFamily};
                        ${({ theme }) => {
                            return breakpointMediaQueries(
                                theme,
                                [
                                    css`
                                        font-family: ${TYPOGRAPHY.accordionItem.fontFamily};
                                        font-style: normal;
                                        font-weight: ${TYPOGRAPHY.accordionItem.weight};
                                        font-size: ${TYPOGRAPHY.accordionItem.sizeSmaller};
                                        line-height: ${TYPOGRAPHY.lineHeight.base};
                                        color: ${getColor("text.main")};
                                        text-transform: ${TYPOGRAPHY.accordionItem.textTransform};
                                    `,
                                    css`
                                        font-family: ${TYPOGRAPHY.accordionItem.fontFamily};
                                        font-style: normal;
                                        font-weight: ${TYPOGRAPHY.accordionItem.weight};
                                        font-size: ${TYPOGRAPHY.accordionItem.sizeSmaller};
                                        line-height: ${TYPOGRAPHY.lineHeight.base};
                                        color: ${getColor("text.main")};
                                        text-transform: ${TYPOGRAPHY.accordionItem.textTransform};
                                    `,
                                    css`
                                        font-family: ${TYPOGRAPHY.accordionItem.fontFamily};
                                        font-style: normal;
                                        font-weight: ${TYPOGRAPHY.accordionItem.weight};
                                        font-size: ${TYPOGRAPHY.accordionItem.sizeSmaller};
                                        line-height: ${TYPOGRAPHY.lineHeight.base};
                                        color: ${getColor("text.main")};
                                        text-transform: ${TYPOGRAPHY.accordionItem.textTransform};
                                    `,
                                    null,
                                    null,
                                ],
                                "max",
                            );
                        }}
                    }
                    > span:last-of-type {
                        justify-content: center;
                        > svg {
                            height: 16px;
                            width: 16px;
                        }
                        > span > span > svg {
                            height: 22px;
                            width: 22px;
                        }
                    }
                }
                > button[aria-expanded="false"] {
                    border-bottom: ${ELEMENTS.accordionItem.borderBottom};
                }
                > button[aria-expanded="true"] {
                    border-bottom: 0px;
                }
            }
        }
    `,
};
